import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import Users from './Users'
import Roles from './Roles'
import Services from './Services/'
import Locations from './Locations/'

// import ManageLandings from './ManageLandings'

import './style.css'

export default function SettingsComponent() {
  let { path } = useRouteMatch()

  return <Switch>
    <Route path={`${path}/users`} component={Users} />
    <Route path={`${path}/roles`} component={Roles} />
    {/* <Route path={`${path}/landing`} component={ManageLandings} /> */}
    <Route path={`${path}/services`} component={Services} />
    <Route path={`${path}/locations`} component={Locations} />
  </Switch>
}